import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected title = 'auth';

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    const sidebarCollapsed = params.get('sidebarCollapsed');
    if (sidebarCollapsed === null) return;
    try {
      localStorage.setItem('re_sidebar_collapsed', sidebarCollapsed);
    } catch {
      /* ignore */
    }
    params.delete('sidebarCollapsed');
    const search = params.toString();
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`,
    );
  }
}
